import React, { FunctionComponent } from 'react';
import Avatar from '@justgiving/avatar';
import gql from 'graphql-tag';
import usePageQuery, {
  buildQuery,
  UsePageQueryResult,
} from '../../hooks/usePageQuery';
import { PageOwnerAvatarFragment } from '../../../types/__generated__';
import { makePhotoUrlFromAbsoluteUrl } from '../../utils/makePhotoUrl';
import styles from './PageOwnerAvatar.scss';

const FRAGMENT = buildQuery(gql`
  fragment PageOwnerAvatar on Page {
    owner {
      id
      name
      avatar
    }
  }
`);

interface PageOwnerAvatarProps {
  size?: 'small' | 'medium' | 'large' | 'xlarge' | 'auto';
}

const PageOwnerAvatar: FunctionComponent<PageOwnerAvatarProps> = ({
  size = 'auto',
}) => {
  const result = usePageQuery<PageOwnerAvatarFragment>(FRAGMENT);

  if (!UsePageQueryResult.hasData(result)) {
    return null;
  }

  const { owner } = result.data;

  return (
    <>
      <div className={styles.image}>
        <Avatar
          picture={
            (owner &&
              owner.avatar &&
              makePhotoUrlFromAbsoluteUrl(owner.avatar)) ||
            ''
          }
          avatarSize={size}
          hasBorder
        />
      </div>
    </>
  );
};

export default PageOwnerAvatar;
